import { Card, CardBody, CardHeader } from "../../../../../_metronic/_partials/controls/index.js"
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import {
  EmptyCard,
  FilterCard,
  RadioButtonGroup,
  TableSkeleton,
  TabsWithIcon
} from "../../../../../component/index.jsx"
import { useTranslation } from "react-i18next"
import TableView, { formatterRowComponent, initialFilterTable } from "../../../../../component/atoms/Tabel/index.jsx"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { BASE_DETAIL_TAB_STRING, BASE_STATUS_ENUM } from "../../../../../constants/StringConstant.js"
import { stringFormatting } from "../../../../helpers/TextHelper.js"
import { sortCaret, toAbsoluteUrl } from "../../../../../_metronic/_helpers/index.js"
import { useDispatch, useSelector } from "react-redux"
import {
  getMasterBaseList,
  getListSubRegionalByRole,
  getListRegionalSelected,
  getBasecampTypeList,
  clearMasterBaseList
} from "../../../../../redux/actions/MasterDataAction.jsx"
import { useUrlParam } from "../../../../hooks/useUrlParams.jsx"
import { useLocation } from "react-router"
import SVG from "react-inlinesvg"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { Link } from "react-router-dom"
import { DetailSvgIcon, EditSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { SelectInput } from "../../../../../component/index.jsx"
import { Skeleton } from "@material-ui/lab"
import { Popup } from "../../../../../component/atoms/Popup/index.jsx"

export const MasterBaseList = ({ history, match: { params: { type } } }) => {
  const subHeader = useSubheader()
  const location = useLocation()
  const formRef = useRef()
  const filterInnerRef = useRef()
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const [showFilter, setShowFilter] = useState(false)
  const [filterOn, setFilterOn] = useState(false)
  const [listRegional, setListRegional] = useState([])
  const [isListOpsTeamOpen, setIsListOpsTeamOpen] = useState(false)
  const [search, setSearch] = useState({
    keyword: "",
  })
  const [filterInitialValues, setFilterInitialValues] = useState({
    regional_id: "",
    sub_regional_id: "",
    type: ""
  })
  // Local state for filter inputs to trigger re-renders
  const [filterValues, setFilterValues] = useState({
    regional_id: "",
    sub_regional_id: "",
    type: ""
  })
  const [listSubRegional, setListSubRegional] = useState([])
  const [selectedListOpsTeam, setSelectedListOpsTeam] = useState([])
  const [popUpOpsTeamTitle, setPopUpOpsTeamTitle] = useState("")
  const [btnFilterDisable, setBtnFilterDisable] = useState(true)
  const [selectedRegional, setSelectedRegional] = useState(null)
  const [selectedSubRegional, setSelectedSubRegional] = useState(null)
  const [enableSubRegional, setEnableSubRegional] = useState(false)

  const { t } = useTranslation()
  const [tabActive, setTabActive] = useState(
    type === BASE_STATUS_ENUM.ACTIVE ? 0 : 1
  )
  const { General, MasterData } = useSelector((state) => state)
  const dispatch = useDispatch()
  const urlParam = useUrlParam()
  const userLogin = JSON.parse(localStorage.getItem("userLogin"))

  useEffect(() => {
    setQueryStringObj(urlParam.getUrlParamsObj)
  }, [urlParam.getUrlParamsObj])

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
    if (queryStringObj?.regional_id || queryStringObj?.sub_regional_id || queryStringObj?.type) {
      setFilterOn(true)
      const newFilterValues = {
        regional_id: queryStringObj?.regional_id || "",
        sub_regional_id: queryStringObj?.sub_regional_id || "",
        type: queryStringObj?.type || ""
      }
      setFilterInitialValues(newFilterValues)
      setFilterValues(newFilterValues)
      setSelectedRegional(queryStringObj?.regional_id || null)
      setSelectedSubRegional(queryStringObj?.sub_regional_id || null)
    }
  }, [queryStringObj])

  useEffect(() => {
    dispatch(getListRegionalSelected())
    dispatch(getBasecampTypeList())
    return () => {
      dispatch(clearMasterBaseList())
    }
  }, [])

  useEffect(() => {
    if (selectedRegional) {
      dispatch(getListSubRegionalByRole(selectedRegional, userLogin?.role))
      setEnableSubRegional(true)
    } else {
      setListSubRegional([])
      setEnableSubRegional(false)
      setSelectedSubRegional(null)
      setFilterValues(prev => ({ ...prev, sub_regional_id: "" }))
      if (filterInnerRef.current) {
        filterInnerRef.current.setFieldValue("sub_regional_id", "")
      }
    }
  }, [selectedRegional])

  useEffect(() => {
    if (filterInnerRef.current) {
      if (userLogin?.regional_id) {
        filterInnerRef.current?.setFieldValue("regional_id", userLogin?.regional_id)
        setSelectedRegional(userLogin?.regional_id)
      }
    }
  }, [filterInnerRef.current, userLogin?.regional_id])

  useEffect(() => {
    if (MasterData?.listSubRegionalByRole) {
      setListSubRegional(
        MasterData.listSubRegionalByRole.map((item) => ({
          label: item.name,
          value: item.id
        }))
      )
    }
  }, [MasterData?.listSubRegionalByRole])

  useEffect(() => {
    if (MasterData?.listRegionalSelected) {
      setListRegional(
        MasterData.listRegionalSelected.map((item) => {
          return {
            label: item.name + " (" + item.code + ")",
            value: item.id
          }
        })
      )
    }
  }, [MasterData?.listRegionalSelected])

  useEffect(() => {
    if (filterInnerRef.current) {
      if (userLogin?.regional_id) {
        const hasRequiredFields =
          filterValues.sub_regional_id ||
          filterValues.type
        setBtnFilterDisable(!hasRequiredFields)
      } else {
        const hasFilterValues =
          filterValues.regional_id ||
          filterValues.sub_regional_id ||
          filterValues.type
        setBtnFilterDisable(!hasFilterValues)
      }
    }
  }, [filterValues, userLogin?.regional_id])

  const handleResetSearch = () => {
    urlParam.resetKeyword()
    setSearch({ keyword: "" })
    setIsActiveSearch(false)
  }

  const handleResetFilter = () => {
    setFilterOn(false)
    const resetValues = {
      regional_id: userLogin?.regional_id || "",
      sub_regional_id: "",
      type: ""
    }
    setFilterInitialValues(resetValues)
    setFilterValues(resetValues)
    setSelectedRegional(userLogin?.regional_id || null)
    setSelectedSubRegional(null)
    if (filterInnerRef.current) {
      filterInnerRef.current.setFieldValue("regional_id", userLogin?.regional_id || "")
      filterInnerRef.current.setFieldValue("sub_regional_id", "")
      filterInnerRef.current.setFieldValue("type", "")
    }

    let param = {
      ...initialFilterTable,
      keyword: search.keyword
    }
    const url = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: url })
  }

  function onSearch(value) {
    setSearch({ keyword: value.keyword })
    setIsActiveSearch(true)
    let param = {
      ...filterInitialValues,
      keyword: value.keyword
    }
    const url = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: url })
  }

  function filterOnSubmit(values) {
    const { submited } = values

    if (submited === true) {
      let param = {
        ...initialFilterTable,
        keyword: search.keyword,
        regional_id: values.values.regional_id || "",
        sub_regional_id: values.values.sub_regional_id || "",
        type: values.values.type || ""
      }
      setFilterInitialValues({
        regional_id: values.values.regional_id || "",
        sub_regional_id: values.values.sub_regional_id || "",
        type: values.values.type || ""
      })
      setFilterOn(true)
      setShowFilter(false)

      const url = getUrlParsingPageFilter(param)
      history.push({ pathname: location.pathname, search: url })
    }
  }

  const handleOpenCloseFilter = (value) => {
    setShowFilter(value)
  }

  const container = ({ type }) => {
    const currentUrlParams = urlParam.getUrlParamsObj || {}
    const currentPageSize = currentUrlParams.size ? parseInt(currentUrlParams.size) : (MasterData?.page?.currentElement ?? 10)

    return (
      <CardBody key={type}>
        {General.loading ? (
          <TableSkeleton column={6} row={10} />
        ) : MasterData?.pageData && MasterData?.pageData.length === 0 ? (
          <EmptyCard
            body={(isActiveSearch || filterOn) ? t("messages_response_searching_not_found") : t("messages_response_empty_state", { name: "Base" })}
            subtitle={(isActiveSearch || filterOn) ? t("messages_response_sub_response_not_found_data") : ""}
            image={(isActiveSearch || filterOn) ? toAbsoluteUrl(ILLUSTRATION_CONSTANTS.EMPTY_DESKTOP) : toAbsoluteUrl(ILLUSTRATION_CONSTANTS.EMPTY_STATE_FARMER)}
          />
        ) : (
          ""
        )}
        <TableView
          dataTable={MasterData?.pageData || []}
          currentPage={MasterData?.page?.currentPage ?? 0}
          currentElement={currentPageSize}
          totalCount={MasterData?.page?.totalCount ?? 1}
          columnProperties={columns}
          loadingGetData={General?.loading}
          callbackAfterPageChange={changePage}
          rowClasses={() => {
            return "cursor-pointer"
          }}
        />
      </CardBody>
    )
  }

  const filterContainer = (
    <>
      <Card className={"card-custom card-shadowless"}>
        <CardHeader title={t("label_location")} className={"px-0"} />
        <CardBody className={"px-0"}>
          <RowModule>
            <SelectInput
              name="regional_id"
              editable={!userLogin?.regional_id}
              label={t("label_regional")}
              placeholder={t("placeholder_select_regional_item")}
              options={listRegional}
              withoutFeedback={true}
              onChange={(e) => {
                if (e) {
                  setSelectedRegional(e)
                } else {
                  setSelectedRegional(null)
                  setSelectedSubRegional(null)
                }
                setFilterValues(prev => ({ ...prev, regional_id: e, sub_regional_id: "" }))
                if (filterInnerRef.current) {
                  filterInnerRef.current.setFieldValue("regional_id", e)
                  filterInnerRef.current.setFieldValue("sub_regional_id", "")
                }
              }}
              value={selectedRegional}
            />
          </RowModule>
          <RowModule>
            {!General?.loading ? <SelectInput
              name="sub_regional_id"
              editable={enableSubRegional}
              label={t("label_sub_regional")}
              placeholder={t("placeholder_select_subregional")}
              options={listSubRegional}
              withoutFeedback={true}
              onChange={(e) => {
                setSelectedSubRegional(e)
                setFilterValues(prev => ({ ...prev, sub_regional_id: e }))
                if (filterInnerRef.current) {
                  filterInnerRef.current.setFieldValue("sub_regional_id", e)
                }
              }}
              value={selectedSubRegional}
            /> : <Skeleton variant={"rect"} />}
          </RowModule>
        </CardBody>
      </Card>
      <Card className={"card-custom card-shadowless"}>
        <CardHeader title={t("label_type")} className={"px-0"} />
        <CardBody className={"px-0"}>
          {General?.loading ? <Skeleton variant={"rect"} />
            : (
              MasterData?.listBaseType?.map((item) => (
                <RadioButtonGroup
                  editable={true}
                  key={item.type_enum}
                  value={item.type_enum}
                  onClick={() => {
                    setFilterValues(prev => ({ ...prev, type: item.type_enum }))
                    if (filterInnerRef.current) {
                      filterInnerRef.current.setFieldValue("type", item.type_enum)
                    }
                  }}
                  checked={filterValues.type === item.type_enum}
                  label={stringFormatting(item.type_string)}
                  name="type"
                />
              ))
            )
          }
        </CardBody>
      </Card>
    </>
  )

  const uiBaseName = (e) => {
    return (
      <>
        <span className={"font-weight-bolder"}>{stringFormatting(e?.code)}</span>
        <br />
        {stringFormatting(e?.warehouse_code)}
        <div className="text-muted font-weight-bold d-block">({stringFormatting(e?.regency_district)})</div>
      </>
    )
  }
  const uiType = (e) => {
    return (
      <>
        {stringFormatting(e?.type)}
      </>
    )
  }
  const uiSubRegional = (e) => {
    return (
      <>
        {stringFormatting(e?.sub_regional_name)}
      </>
    )
  }

  const uiOpsTeam = (e) => {
    if (!Array.isArray(e?.ops_team)) return null
    return (
      <div className={"d-flex align-items-center"} style={{ gap: 8 }}>
        <span>{t("label_x_people", { count: stringFormatting(e?.ops_team.length) })}</span>
        <div className={"cursor-pointer"} onClick={() => {
          setPopUpOpsTeamTitle(stringFormatting(e?.code))
          setSelectedListOpsTeam(e?.ops_team)
          setIsListOpsTeamOpen(true)
        }}>
          <SVG src={toAbsoluteUrl(ICON_CONSTANTS.INFORMATION)} />
        </div>
      </div>
    )
  }

  const uiAddress = (e) => {
    return (
      <>
        {stringFormatting(e?.full_address)}
      </>
    )
  }

  const columns = [
    {
      dataField: "code",
      text: t("table_header_base_name"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiBaseName
      },
      sortCaret: sortCaret,
      headerStyle: () => {
        return { width: "10%" }
      }
    },
    {
      dataField: "type",
      text: t("label_type"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiType
      },
      headerStyle: () => {
        return { width: "6%" }
      }
    },
    {
      dataField: "sub_regional_id",
      text: t("table_header_sub_regional"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiSubRegional
      },
      headerStyle: () => {
        return { width: "10%" }
      }
    },
    {
      dataField: "ops_team",
      text: t("sub_header_ops_team"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiOpsTeam
      },
      headerStyle: () => {
        return { width: "8%" }
      }
    },
    {
      dataField: "full_address",
      text: t("label_full_address"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAddress
      },
      headerStyle: () => {
        return { width: "28%" }
      }
    },
    {
      text: t("table_header_action"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className={'d-flex align-items-center'}>
            <Link
              to={RoutesConstants.MASTER_DATA.BASE.EDIT(e?.id)}>
              <div className="btn btn-icon btn-detail btn-hover-secondary btn-md">
                <EditSvgIcon size="2x" />
              </div>
            </Link>
            <Link
              to={RoutesConstants.MASTER_DATA.BASE.DETAIL(e?.id, BASE_DETAIL_TAB_STRING.DETAIL)}>
              <div className="btn btn-icon btn-detail btn-hover-secondary btn-md">
                <DetailSvgIcon size="2x" />
              </div>
            </Link>
          </div>
        )
      },
      headerStyle: () => {
        return { width: "5%" }
      }
    }
  ]

  const popUpOpsTeamTableColumns = [
    {
      dataField: "code",
      text: t("table_header_id_ops_team"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <span className={"font-weight-bolder"}>{stringFormatting(e?.code)}</span>
        )
      },
    },
    {
      dataField: "name",
      text: t("table_header_name"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className={"d-flex flex-column"}>
            <span className={"font-weight-bolder"}>{stringFormatting(e?.name)}</span>
            <span>{stringFormatting(e?.phone_number)}</span>
          </div>
        )
      },
    },
    {
      dataField: "role",
      text: t("table_header_role"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <span>{stringFormatting(e?.role)}</span>
        )
      },
    },
  ]

  const changePage = useCallback(
    (param) => {
      const currentUrlParams = urlParam.getUrlParamsObj || {}
      const preservedPageSize = param.pageSize || currentUrlParams.size

      let newParam
      if (param.sortField != null) {
        newParam = getUrlParsingPageFilter({
          ...filterInitialValues,
          ...search,
          ...param,
          size: preservedPageSize,
          sort: param.sortField + "," + param.sortOrder
        })
      } else {
        newParam = getUrlParsingPageFilter({
          ...filterInitialValues,
          ...search,
          ...param,
          size: preservedPageSize
        })
      }
      history.push({ pathname: location.pathname, search: newParam })
    },
    [search, filterInitialValues, urlParam.getUrlParamsObj]
  )

  const tabContents = () => {
    const labels = [{
      label: t("label_active"),
      labelTooltip: "",
      icon: ""
    }, {
      label: t("label_inactive"),
      labelTooltip: "",
      icon: ""
    }]
    const components = [container({ type: BASE_STATUS_ENUM.ACTIVE }), container({ type: BASE_STATUS_ENUM.INACTIVE })]

    return {
      labels,
      components
    }
  }

  const handleChangeTab = (data) => {
    setTabActive(data)

    let param = {
      ...initialFilterTable,
      keyword: search.keyword,
      regional_id: filterInitialValues.regional_id || "",
      sub_regional_id: filterInitialValues.sub_regional_id || "",
      type: filterInitialValues.type || ""
    }
    const s = getUrlParsingPageFilter(param)

    if (data === 0) {
      history.push({ pathname: RoutesConstants.MASTER_DATA.BASE.LIST(BASE_STATUS_ENUM.ACTIVE), search: s })
    } else if (data === 1) {
      history.push({ pathname: RoutesConstants.MASTER_DATA.BASE.LIST(BASE_STATUS_ENUM.INACTIVE), search: s })
    }
  }

  useEffect(() => {
    subHeader.setTitle(t("sub_header_base"))
  }, [])

  useEffect(() => {
    if (type === BASE_STATUS_ENUM.ACTIVE) {
      setTabActive(0)
    } else if (type === BASE_STATUS_ENUM.INACTIVE) {
      setTabActive(1)
    }
  }, [type])

  useEffect(() => {
    const result = location?.search
    dispatch(getMasterBaseList(type, result))
  }, [location.search, type])

  return (
    <>
      <FilterCard
        placeholder={t("placeholder_input_base_name")}
        onSubmitForm={onSearch}
        initialValues={search}
        name={"keyword"}
        trigerReset={handleResetSearch}
        innerRef={formRef}
        filterInnerRef={filterInnerRef}
        filterHandleSubmit={filterOnSubmit}
        filterFormInitialValues={filterInitialValues}
        filterComponent={filterContainer}
        filterOnReset={handleResetFilter}
        showFilter={showFilter}
        handleOpenCloseFilter={handleOpenCloseFilter}
        filterOn={filterOn}
        btnDisable={btnFilterDisable}
        isActiveSearch={isActiveSearch}
      />
      <Card>
        <TabsWithIcon
          header={<div className={"mt-4"} />}
          labelTab={tabContents().labels}
          componentTab={tabContents().components}
          changeTab={handleChangeTab}
          initValue={tabActive}
        />
      </Card>
      <Popup
        show={isListOpsTeamOpen}
        titleCustom={
          <h4 className="mb-0 font-weight-bolder">
            {popUpOpsTeamTitle}
          </h4>
        }
        size={"lg"}
        bodyCustomClassName={"h-50"}
        contentClassName={"h-50"}
        closeButton={true}
        onCancel={() => {
          setPopUpOpsTeamTitle("")
          setSelectedListOpsTeam([])
          setIsListOpsTeamOpen(false)
        }}
        showButton={false}
        bodyCustom={
          <div style={{ height: "48vh", overflowY: "auto", overflowX: "unset" }}>
            <TableView
              dataTable={selectedListOpsTeam}
              dataSize={selectedListOpsTeam.length}
              columnProperties={popUpOpsTeamTableColumns}
              loadingGetData={false}
              disablePagination={true}
              callbackAfterPageChange={() => { }} />
          </div>
        }
      />
    </>
  )
}

